import { useAuthStore } from "@/stores/auth";
import { Link } from "react-router-dom";

export default function HomePage() {
  const user = useAuthStore((s) => s.user)!;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">看板</h1>
        <p className="text-sm text-muted-foreground mt-1">
          欢迎，<strong>{user.displayName || user.email}</strong>。
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <Stat title="角色" value={user.role} />
        <Stat title="所属公司" value={user.organizationId ? user.organizationId.slice(0, 8) : "—"} />
        <Stat title="账户邮箱" value={user.email} />
      </div>

      <div className="rounded-lg border border-border bg-background p-6">
        <h2 className="font-medium mb-3">快捷入口</h2>
        <div className="flex gap-4 text-sm flex-wrap">
          <Link to="/ad-accounts" className="text-primary underline">
            广告账户 →
          </Link>
          {user.role !== "MEMBER" && (
            <Link to="/invitations" className="text-primary underline">
              管理邀请 →
            </Link>
          )}
          {user.role === "SUPER_ADMIN" && (
            <Link to="/organizations" className="text-primary underline">
              公司管理 →
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}

function Stat({ title, value }: { title: string; value: string }) {
  return (
    <div className="rounded-lg border border-border bg-background p-5">
      <div className="text-xs text-muted-foreground">{title}</div>
      <div className="mt-1 text-base font-medium break-all">{value}</div>
    </div>
  );
}
